// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9af52f1b","455":"cb510c7d"}[chunkId] + ".chunk.js";
};